document.addEventListener('DOMContentLoaded', () => {
  function hideWhatsappRate() {
    const rateBlocks = document.querySelectorAll(
      '.shipping-option, .cart-shipping, .rate, .radio-wrapper, .cart-drawer__shipping, .cart__shipping'
    );

    rateBlocks.forEach(block => {
      const titleEl = block.querySelector('.radio__label, .shipping-option__label, .shipping-rate__name, .cart-shipping__label, .name');
      const costEl = block.querySelector('.shipping-rate__cost, .price, .shipping-option__price, .cart-shipping__cost, .rate__cost');

      if (titleEl && costEl && titleEl.textContent.includes('Otras comunas de Santiago y Regiones')) {
        costEl.style.display = 'none';
      }
    });
  }

  hideWhatsappRate();
  // Reintenta si se carga dinámicamente
  setTimeout(hideWhatsappRate, 1500);
});
